import React, {memo, ReactElement, useContext, useEffect} from "react";
import {Props} from "./DelayedDispatch.types";
import {CompareModule} from "modules/Compare.module";
import {DatePicker, TimePicker, useForm} from "@witivio_teamspro/northstar-form";
import {Checkbox, Flex} from "@fluentui/react-northstar";
import languageObject from "../../../translations";
import moment from "moment";
import {AppContext} from "../../../services/AppContext";

export const DelayedDispatch = memo((props: Props): ReactElement | null => {
    const context = useContext(AppContext);

    const form = useForm({
        disabled: props.disabled,
        locale: context.teams.locale,
        items: {
            date: DatePicker({
                initialValue: new Date().toISOString(),
                clearable: false,
                maxDate: moment().add(30, 'days').toDate(),
            }),
            time: TimePicker({
                initialValue: {hour: moment().hour() + 1, minutes: 0},
                clearable: false,
            })
        }
    });

    const {date, time} = form.state.data;

    useEffect(() => {
        if (!date || !time) return;
        const dateTime = moment(date).startOf("day").add(time.hour, "hour").add(time.minutes, "minute").toISOString(false);
        props.onDateChange(dateTime);
    }, [date, time]);

    return (
        <Flex gap={"gap.small"} vAlign={"center"}>
            <Checkbox
                disabled={props.disabled}
                checked={props.isDelayed}
                label={languageObject.translate("DelayedDispatch")}
                onClick={props.onToggleDelayedDispatch}
            />
            {props.isDelayed &&
                <Flex vAlign={"center"} gap={"gap.smaller"}>
                    {form.formItems.date}
                    {form.formItems.time}
                </Flex>
            }
        </Flex>
    )
}, CompareModule.areObjectsEqual);